import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { Filter } from '../../models/filter-models';
import { BaseTypeTier, JewelleryType, Rarity } from "../../models/enums";
import { EquipmentType } from "../../models/equipment-type.enum";
import { FilterService } from '../../services/filter.service';
import { SelectGearTierComponent } from '../../common/select/select-gear-tier/select-gear-tier.component';
import { SelectComponent, SelectOptionComponent } from '../../common/select/select.component';
import { ActiveRules } from '../../services/filter-generator.service';
import { BaseComponent } from '../../common/base.component';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';
import { BaseType } from '../../models/item-data-models';
import { ItemDataService } from '../../services/item-data.service';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { DynamicContentComponent } from '../../common/dynamic-content/dynamic-content.component';

@Component({
  selector: 'app-unidentified-equipment-filters-poe2',
  imports: [FormsModule, FilterTitleComponent, SelectGearTierComponent, SelectComponent, SelectOptionComponent,
    EquipmentTierPickerComponent, AutocompleteComponent, DynamicContentComponent],
  templateUrl: './unidentified-equipment-filters-poe2.component.html',
  styleUrl: './unidentified-equipment-filters-poe2.component.scss'
})
export class UnidentifiedEquipmentFiltersPoe2Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;

  jewelleryTypes: BaseType[] = [];

  BaseTypeTier = BaseTypeTier;
  EquipmentType = EquipmentType;
  Rarity = Rarity;

  constructor(private filterService: FilterService, private itemDataService: ItemDataService) {
    super();

    this.jewelleryTypes = [
      { name: 'Amulets', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Amulets')!.baseTypes[0].image! },
      { name: 'Rings', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Rings')!.baseTypes[0].image! },
      { name: 'Belts', image: this.itemDataService.getItemData().find(i => i.itemClass === 'Belts')!.baseTypes[0].image! },
    ];
  }

  toggleShowTieredRareGear = () => {
    this.filter.showTieredRareGear = !this.filter.showTieredRareGear; this.updateFilter();
    if (!this.filter.showTieredRareGear) {
      this.filter.showLowTierTieredRareGear = false;
    }
  }

  toggleShowTieredMagicGear = () => { this.filter.showTieredMagicGear = !this.filter.showTieredMagicGear; this.updateFilter();
    if (!this.filter.showTieredMagicGear) {
      this.filter.showLowTierTieredMagicGear = false;
    }
  }

  toggleShowLowTierTieredRareGear = () => { this.filter.showLowTierTieredRareGear = !this.filter.showLowTierTieredRareGear; this.updateFilter(); }
  toggleShowLowTierTieredMagicGear = () => { this.filter.showLowTierTieredMagicGear = !this.filter.showLowTierTieredMagicGear; this.updateFilter(); }

  toggleShowTieredRareJewellery = () => { this.filter.showTieredRareJewellery = !this.filter.showTieredRareJewellery; this.updateFilter(); }
  toggleShowTieredMagicJewellery = () => { this.filter.showTieredMagicJewellery = !this.filter.showTieredMagicJewellery; this.updateFilter(); }

  showTieredRareJewelleryTypesChanged(event: string[]) {
    this.filter.showTieredRareJewelleryTypes = event.map(e => e as JewelleryType);
    this.updateFilter();
  }

  showTieredMagicJewelleryTypesChanged(event: string[]) {
    this.filter.showTieredMagicJewelleryTypes = event.map(e => e as JewelleryType);
    this.updateFilter();
  }

  updateFilter() {
    this.filterService.updateFilter();
  }

  getLowerTierName(gearTier: BaseTypeTier): string {
    switch (gearTier) {
      case BaseTypeTier.Master:
        return 'Elite';
      case BaseTypeTier.Elite:
        return 'Expert';
      case BaseTypeTier.Expert:
        return 'Adv.';
      default:
        return 'Basic';
    }
  }
}
